import { Tag } from "antd";
import { ReactNode } from "react";
import { getRandomColor } from "../../utils/common/generateRandomColor.ts";

interface TagOptionProps {
  label: ReactNode;
  closable?: boolean;
  onClose?: () => void;
  color?: string;
}

export const TagOption = (props: TagOptionProps) => {
  const { label, closable, onClose, color } = props;

  const tagColor = color || getRandomColor();

  const onPreventMouseDown = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Tag
      color={tagColor}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};
